import React from "react";
import clsx from "clsx";
import { useAddTrainessToProcessGroupMutation } from "@lib/study-center";
import { setInternalInfo } from "@store/internal-study/list-store";
import { ListShortDataT } from "@interfaces/internal-study/list";
import useModal from "@modals/modal-hook";
import useStyles from "@ui/material-ui-styles";

import { FormControl, InputLabel, MenuItem } from "@mui/material";
import Select from "@mui/material/Select";

import style from "@scss/modals/company/workspace-document.module.scss";

const InternalListAddEmployeeToGroup = () => {
  const addTrainessToProcessGroupMutation =
    useAddTrainessToProcessGroupMutation();

  const { modalComponent, modalData, close } = useModal();
  const classes = useStyles();

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const modalBtn = document.querySelector(
      "button.modal_btn"
    ) as HTMLButtonElement;
    modalBtn.disabled = true;

    const groupField = document.querySelector(
      '[name="group"]'
    ) as HTMLInputElement;

    if (groupField && modalData.id && modalData?.members.length) {
      addTrainessToProcessGroupMutation.mutate(
        {
          id: modalData.id,
          index: +groupField.value,
          members: modalData.members,
        },
        {
          onSuccess: (data: any) => {
            setInternalInfo(data as ListShortDataT);
            close();
          },
        }
      );
    }
  };

  return (
    <div className={clsx(style.workspace_document_modal)}>
      <p className="modal_title">
        Добавление {modalData.members.length > 1 ? "сотрудников" : "сотрудника"}{" "}
        в XML файл (группу)
      </p>
      <div className="underline" />
      <form className={`modal_content ${classes.root}`} onSubmit={handleSubmit}>
        {modalData.members.map((e: any) => (
          <p>{e.name}</p>
        ))}
        <FormControl variant="filled" className={clsx(style.period_select)}>
          <InputLabel id="ot-specialist">Группа</InputLabel>
          <Select labelId="ot-specialist" name="group">
            {modalData.groups.map((item: any, i: number) => (
              <MenuItem key={i} value={i}>
                {item.members[0].name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <button type="submit" className="modal_btn">
          {modalComponent.btnText}
        </button>
      </form>
    </div>
  );
};

export default InternalListAddEmployeeToGroup;
